import { Snackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import { useRecoilState } from "recoil";
import { snackbarUpdateStatus } from "../../store/simulator";

interface IErrorSnackbarAlertProps {
	errorTitle: string;
	secondaryText?: string;
	id?: string;
	bgColor?: string | null;
	showIcon?: boolean;
	maxWidth?: string;
}

const useStyles = makeStyles({
	icon: {
		display: "none",
	},
});

const ErrorSnackbarAlert = (props: IErrorSnackbarAlertProps) => {
	const { errorTitle, secondaryText, bgColor, showIcon, maxWidth } = props;
	const classes = useStyles();
	const [snackBarUpdateStatus, setSnackBarUpdateStatus] = useRecoilState(snackbarUpdateStatus);
	const backgroundColor = bgColor || "#FEF2F1";
	const textColor = bgColor === "rgba(28, 49, 69, 0.90)" ? "#FFFFFF" : "#762400";
	const padding = bgColor === "rgba(28, 49, 69, 0.90)" ? "16px" : "6px 16px";

	const handleClose = (_event?: React.SyntheticEvent | Event) => {
		if (props.id) {
			setSnackBarUpdateStatus((prevState) => ({
				...prevState,
				hasError: false,
				simulationId: prevState.simulationId.filter((ids) => ids !== props.id),
			}));
		}

		setSnackBarUpdateStatus((prevState) => ({ ...prevState, hasError: false }));
	};

	const handleAlertClose = (_event?: React.SyntheticEvent | Event) => {
		setSnackBarUpdateStatus((prevState) => ({ ...prevState, hasError: false }));
	};

	const alertClasses = showIcon ? { icon: classes.icon } : {};

	return (
		<Snackbar
			open={snackBarUpdateStatus.hasError}
			autoHideDuration={8000}
			onClose={handleClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			style={{ maxWidth: maxWidth || "438px" }}
		>
			<Alert
				onClose={handleAlertClose}
				severity="error"
				variant="filled"
				classes={alertClasses}
				style={{ color: textColor, background: backgroundColor, borderRadius: "4px", padding }}
			>
				<span style={{ fontWeight: 600 }}>{errorTitle}</span>
				{secondaryText && secondaryText}
			</Alert>
		</Snackbar>
	);
};

export default ErrorSnackbarAlert;
